const events = {};

export function broadcast(eventName, detail) {
  if (events[eventName]) {
    events[eventName].forEach(cb => cb({ eventName, detail }));
  }
}

export function listen(eventName, callback) {
  if (!events[eventName]) {
    events[eventName] = [];
  }
  events[eventName].push(callback);

  return () => {
    const index = events[eventName].indexOf(callback);
    events[eventName].splice(index, 1);
  };
}

export default function (eventName) {
  return {
    broadcast: broadcast.bind(null, eventName),
    listen: listen.bind(null, eventName)
  };
}
